import React from 'react';
import {makeStyles} from '@mui/styles';
import {Grid, Typography} from '@mui/material';

import PageHeader from "../../../components/PageHeader/PageHeader";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import NewLicense from "./components/NewLicense";
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    margin: 0,
    padding: 0
  }
}));

const RequestLicense = (props) => {
  const classes = useStyles();
  const { requestType,
    randomPhrase,
    request_filename } = props.location.state;


  const user = useSelector(state => state.authentication.user);

  return (
    <div className={classes.root}>
      <PageHeader title={(requestType === 'New') ? 'MISSING LICENSE' : 'REPLACE LICENSE'} subTitle={"Request License"}/>
      <Card  className={classes.content}>
        <CardBody>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              xs={12}
            >
              {(requestType === 'New') ? (
                <NewLicense
                   randomPhrase={randomPhrase}
                   request_filename={request_filename}
                />) : (
                  <Typography variant="h1">
                    errorMessage
                  </Typography>
                )}
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
};

export default RequestLicense;
